import { BrightnessSlider } from '../BrightnessSlider';
type BrightnessControlsProps = {
  disabled: boolean;
};

export const BrightnessControls = ({ disabled }: BrightnessControlsProps) => {
  return (
    <BrightnessSlider title="Brightness level" disabled={disabled} step={1} min={0} max={100} />
  );
};
